import React from 'react'
import { CallToAction, Heading } from '@scentregroup/ui'
import ExternalLink from '../external-link'
import style from './index.module.scss'

const WestfieldPlusJoinNow: React.FC = () => (
  <div className={style.subscribeSection}>
    <Heading type="small" className={style.subscribeHeading}>
      Get more every day with Westfield Plus
    </Heading>
    <CallToAction
      inverted
      fullWidth
      element={ExternalLink}
      url="/westfield-plus"
      data-test-id="subscribe-button"
    >
      Join Now
    </CallToAction>
  </div>
)

export default WestfieldPlusJoinNow
